import { DSM3ColumnTable } from '@eredes/dsm3';

import { RequestViewModel } from './request.view-model';

import { ApiPaginationModel } from 'app/_core/models/api-pagination.model';

export class RequestListViewModel {
  pagination: ApiPaginationModel = null;
  request: RequestViewModel[] = [];
  hasFiltersEnabled = false;
  isExporting = false;

  public columnsTable: DSM3ColumnTable[] = [
    { label: 'Estado', prop: 'statusTitle' },
    { label: 'ID', prop: 'requestMainId' },
    { label: 'CPE', prop: 'requestCpe' },
    { label: 'Tipo', prop: 'requestType' },
    { label: 'Subtipo', prop: 'requestSubType' },
    { label: 'Data de Criação', prop: 'createdAt' },
  ];
}
